import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import logo from '../../../assets/logo.png';
import css from './Collaboration.module.css';

const Collaboration = ({ intl }) => {
  return (
    <div className={css.collaborationContainer}>
      <div className={css.collaborationContent}>
        <div className={css.leftSide}>
          <p className={css.copyrightText}>
            <FormattedMessage id="Collaboration.copyrightText" />
          </p>
        </div>
        <div className={css.rightSide}>
          <span className={css.collaborationText}>
            <FormattedMessage id="Collaboration.collaborationText" />
          </span>
          <a
            href="http://www.rennworks.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            className={css.logoLink}
          >
            <img
              src={logo}
              alt={intl.formatMessage({ id: 'Collaboration.logoAltText' })}
              className={css.logoImage}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

Collaboration.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Collaboration);
